import { QueryErrorBoundary } from '@sara/ui/components/query-error-boundary';
import { CandidateDetailContainerContent } from './CandidateDetailContainerContent';
import type { CandidateDetailDto } from '@sara/api-client';

interface CandidateDetailContainerProps {
  orgId: string;
  candidate: CandidateDetailDto;
}

export function CandidateDetailContainer(props: CandidateDetailContainerProps) {
  return (
    <QueryErrorBoundary>
      <CandidateDetailContainerContent {...props} />
    </QueryErrorBoundary>
  );
}
